import {useTranslation} from "react-i18next";
import {useSelector} from "react-redux";

import {selectAssociatedOutputParamOutputCurried} from "../../redux/objectParametersSelectors";
import InputTextField from "./InputTextField";
import ParameterFieldContainer from "./ParameterFieldContainer";
import {getResourceColor, useInputParameterDef} from "./paramHooks";

export default function ParameterInputText({
    ref,
    parameter,
    parameterType,
    label,
    id,
    parameter_details_def,
    associatedOutputParam,
    events,
    suggestionPlaceholder,
}) {
    const {t} = useTranslation();
    const parameterData = useInputParameterDef(parameter, parameter_details_def);
    const associatedOutputParamValue = useSelector(selectAssociatedOutputParamOutputCurried(associatedOutputParam));

    if (!parameterData) return null;

    const hasAssociatedOutput = associatedOutputParamValue !== undefined && associatedOutputParamValue !== null;

    // Vorschlag (#19518) hat den niedrigsten Rang: ƒ()-Wert und "Keine Angabe" gehen vor.
    let placeholder = hasAssociatedOutput
        ? `${t("object.associatedOutputParamPrefix")} ${associatedOutputParamValue}`
        : (suggestionPlaceholder ?? null);

    const mapEventToValue = (e) => {
        const newValue = e.target.value;
        // #17901 benötigte Parameter Eingaben dürfen nicht explizit auf leer (e.g. empty) gesetzt werden
        const emptyValue = parameterData?.required === true ? null : "empty";
        return {value: newValue || emptyValue};
    };

    return (
        <ParameterFieldContainer
            id={id}
            label={label}
            parameter={parameter}
            parameterType={parameterType}
            parameter_details_def={parameter_details_def}
            showDescription
            hasAssociatedOutputParam={!!associatedOutputParam}
            associatedOutputParamValue={associatedOutputParamValue}
            eventToValueMapper={mapEventToValue}
            renderControl={({className, onChange, value, activeParameterType, hasConflict, disabled, allValues}) => {
                const color = getResourceColor(activeParameterType, hasConflict);
                placeholder = allValues?.reva === "empty" ? t("object.valueTooltip.revaEmpty") : placeholder;

                return (
                    <InputTextField
                        id={id}
                        ref={ref}
                        value={value}
                        className={`text-${color} ${className} ${parameter}`}
                        disabled={disabled}
                        placeholder={placeholder}
                        hasAssociatedOutput={hasAssociatedOutput || !!suggestionPlaceholder}
                        onChange={onChange}
                        onBlur={events?.onBlur}
                    />
                );
            }}
        />
    );
}
